<template>
  <el-drawer
    :title="$t('YOUR_MSGS')"
    :visible.sync="drawer"
    :direction="$i18n.locale == 'fa' ? 'ltr' : 'rtl'"
  >
    <div class="space-y-2 notification_holder" v-if="notification.length > 0">
      <el-button
        size="small"
        type="info"
        round
        class="absolute top-5 right-28"
        @click="readAllNotifications"
      >
        {{ $t('READ_ALL') }}
      </el-button>

      <Notice
        :noTitle="false"
        v-for="(notif, index) in notification"
        :key="index"
        class="single-notification hover:bg-black"
        :class="{ 'text-left': $i18n.locale != 'fa' }"
      >
        <router-link
          v-if="getNotificationLink(notif)"
          :to="getNotificationLink(notif)"
          class="block"
          :title="$t('VIEW')"
          @click.native="closeDrawer"
        >
          <div
            class="absolute top-3"
            @click="markAsRead(notif.id)"
            :class="{
              'left-4': $i18n.locale == 'fa',
              'right-4': $i18n.locale != 'fa',
            }"
          >
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('I_READ')"
              placement="bottom"
            >
              <i
                class="
                  el-icon-view
                  text-lg
                  cursor-pointer
                  view-notif
                  text-gray-900
                "
              ></i>
            </el-tooltip>
          </div>
          <span
            class="
              text-sm
              flex
              items-center
              reminder-title
              font-bold
              text-gray-900
              mb-2
              gap-2
            "
            :class="{
              'pl-4': $i18n.locale == 'fa',
              'pr-4': $i18n.locale != 'fa',
            }"
          >
            <img
              v-if="getNotificationIcon(notif).type === 'image'"
              :src="
                require(`@/assets/images/${getNotificationIcon(notif).value}`)
              "
              alt="icon"
              class="w-4 h-4"
            />
            <i
              :class="getNotificationIcon(notif).value"
              class="text-carpo"
              v-else
            ></i>
            <span>
              {{
                $i18n.locale == 'fa'
                  ? notif.notification.type.fa_title
                  : notif.notification.type.en_title
              }}
            </span>
          </span>
          <p
            class="text-sm leading-5 font-light"
            v-html="
              $i18n.locale == 'fa'
                ? notif.notification.fa_body
                : notif.notification.en_body
            "
          ></p>
          <p
            class="text-xs text-gray-700 font-thin mt-2 pr-2"
            :class="{
              'text-left': $i18n.locale == 'fa',
              'text-right': $i18n.locale != 'fa',
            }"
            dir="ltr"
          >
            {{
              new Date(notif.notification.created).toLocaleDateString('fa-IR')
            }}
            |
            {{
              new Date(notif.notification.created).toLocaleTimeString('fa-IR')
            }}
          </p>
        </router-link>
        <div v-else class="block">
          <div
            class="absolute top-3"
            @click="markAsRead(notif.id)"
            :class="{
              'left-4': $i18n.locale == 'fa',
              'right-4': $i18n.locale != 'fa',
            }"
          >
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('I_READ')"
              placement="bottom"
            >
              <i
                class="
                  el-icon-view
                  text-lg
                  cursor-pointer
                  view-notif
                  text-gray-900
                "
              ></i>
            </el-tooltip>
          </div>
          <span
            class="
              text-sm
              flex
              items-center
              reminder-title
              font-bold
              text-gray-900
              mb-2
              gap-2
            "
            :class="{
              'pl-4': $i18n.locale == 'fa',
              'pr-4': $i18n.locale != 'fa',
            }"
          >
            <img
              v-if="getNotificationIcon(notif).type === 'image'"
              :src="
                require(`@/assets/images/${getNotificationIcon(notif).value}`)
              "
              alt="icon"
              class="w-4 h-4"
            />
            <i
              :class="getNotificationIcon(notif).value"
              class="text-carpo"
              v-else
            ></i>
            <span>
              {{
                $i18n.locale == 'fa'
                  ? notif.notification.type.fa_title
                  : notif.notification.type.en_title
              }}
            </span>
          </span>
          <p
            class="text-sm leading-5 font-light"
            v-html="
              $i18n.locale == 'fa'
                ? notif.notification.fa_body
                : notif.notification.en_body
            "
          ></p>
          <p
            class="text-xs text-gray-700 font-thin mt-2 pr-2"
            :class="{
              'text-left': $i18n.locale == 'fa',
              'text-right': $i18n.locale != 'fa',
            }"
            dir="ltr"
          >
            {{
              new Date(notif.notification.created).toLocaleDateString('fa-IR')
            }}
            |
            {{
              new Date(notif.notification.created).toLocaleTimeString('fa-IR')
            }}
          </p>
        </div>
      </Notice>
    </div>
    <div v-else>
      <p class="text-sm text-center leading-5 font-bold text-gray-700">
        {{ $t('NO_UNREAD') }}
      </p>
    </div>
  </el-drawer>
</template>

<script>
import Notice from '@/components/elements/notice'
export default {
  data() {
    return {
      direction: 'ltr',
      notification: [],
      intervalId: null,
      readingAll: false,
    }
  },
  components: {
    Notice,
  },
  computed: {
    drawer: {
      get: function () {
        return this.$store.getters.drawer
      },
      set: function (newValue) {
        this.$store.commit('OPEN_DRAWER', false)
      },
    },
  },
  methods: {
    readAllNotifications() {
      if (this.notification.length === 0) return

      this.readingAll = true
      const notificationIds = this.notification.map((notif) => notif.id)

      this.$store
        .dispatch('readAllNotifications', notificationIds)
        .then((res) => {
          if (res) {
            this.notification = []
            this.$notify.success({
              title: this.$i18n.t('READ_ALL_SUCCESS'),
              duration: 4000,
              customClass: 'succ_msg',
            })
          }
        })
        .finally(() => {
          this.readingAll = false
        })
    },
    getNotificationIcon(notif) {
      const type = notif.notification.type.en_title.toLowerCase()

      if (type.includes('driver')) {
        return { type: 'image', value: 'car-steering-wheel.svg' }
      } else if (type.includes('vehicle')) {
        return { type: 'image', value: 'local_shipping.svg' } // Replace with actual icon class
      } else if (type.includes('service')) {
        return { type: 'icon', value: 'el-icon-odometer' } // Replace with actual icon class
      } else if (type.includes('fence')) {
        return { type: 'icon', value: 'el-icon-map-location' }
      } else if (type.includes('announcement')) {
        return { type: 'icon', value: 'el-icon-bell' }
      }
      return { type: 'icon', value: 'el-icon-bell' }
    },

    getNotificationLink(notif) {
      const typeMap = {
        driver: '/fa/reminders?active=drivers',
        vehicle: '/fa/reminders?active=comapny-vehicles',
        service: '/fa/reminders?active=company-vehicle-services',
        fence: '/fa/reports/geofence-rules',
        announcement: null, // No specific route for announcements
        newfeature: '',
      }

      const selectedType = notif.notification.type.en_title.toLowerCase()

      const selectedQuery = Object.keys(typeMap).find((key) =>
        selectedType.includes(key)
      )

      // Return the mapped route or null if no match found
      return typeMap[selectedQuery] || null
    },

    markAsRead(id) {
      this.$store.dispatch('readNotification', id).then((res) => {
        if (res) {
          this.notification = this.notification.filter(
            (notif) => notif.id !== id
          )
          this.$notify.success({
            title: this.$i18n.t('READ_MSG'),
            duration: 4000,
            customClass: 'succ_msg',
          })
        }
      })
    },
    fetchNotifications() {
      this.$store.dispatch('notifications').then((res) => {
        if (res) {
          this.notification = res
        }
      })
    },
    closeDrawer() {
      this.drawer = false // Close the drawer
    },
  },
  mounted() {
    this.fetchNotifications() // Fetch notifications initially
    // Set up the interval to fetch notifications periodically
    this.intervalId = setInterval(this.fetchNotifications, 300000) // 5 minutes
  },
  beforeDestroy() {
    // Clear the interval when the component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
}
</script>

<style lang="scss">
.el-drawer__body {
  text-align: right;
  direction: rtl;
}

.el-drawer__header {
  padding: 20px 12px 0;
  flex-flow: row-reverse wrap;
}

.notification_holder {
  max-height: 90vh;
  overflow-y: auto;

  ul {
    li {
      position: relative;
      padding: 0 1.2em 7px 0;

      &::before {
        content: '✔  ';
        position: absolute;
        top: 1px;
        right: 0;
        color: #ff5604;
      }
    }
  }

  .view-notif {
    font-weight: bold;
  }
}

body .notification_holder > div.single-notification {
  @apply bg-opacity-40;
}

@media (max-width: 500px) {
  div.el-drawer {
    width: 70% !important;
  }
}
</style>
<style scoped lang="scss">
.notice-yellow {
  &:hover {
    .reminder-title {
      @apply text-yellow-700 transition-all duration-200;
    }
  }
}
</style>
